module.exports = __webpack_public_path__ + "images/giftTree/family.1a7e0ae6ac482a43048906afafd4fd7f.png";